module.exports = __webpack_public_path__ + "media/images/front/icon_facebook-1e1320c27a0c41aabaecab24d8655fca.png";